import * as React from "react"
import { CloseIcon, KeyboardArrowDownIcon } from "@design/icons/material-symbols"
import { Button } from "@design/ui/button"
import { Kbd } from "@design/ui/kbd"

export interface SheetWiring {
  headerSheetTitle?: string
  close: React.ComponentProps<typeof CloseIcon>
  headerSheetShowDescription?: boolean
  headerSheetDescription?: string
  sheetSlot?: React.ReactNode
  sheetShowFooter?: boolean
  button: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  buttonShowIconStart?: boolean
  buttonLabel?: string
  buttonShowKbd?: boolean
  kbd: Omit<React.ComponentProps<typeof Kbd>, "children">
  kbdShowLeftIcon?: boolean
  kbdLabel?: string
  kbdShowRightIcon?: boolean
  buttonShowIconEnd?: boolean
  button2: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  buttonShowIconStart2?: boolean
  buttonLabel2?: string
  buttonShowKbd2?: boolean
  kbd2: Omit<React.ComponentProps<typeof Kbd>, "children">
  kbdShowLeftIcon2?: boolean
  kbdLabel2?: string
  kbdShowRightIcon2?: boolean
  buttonShowIconEnd2?: boolean
  sheetShowScroller?: boolean
  button3: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  iconCaretDown: React.ComponentProps<typeof KeyboardArrowDownIcon>
}

export const SheetContext = React.createContext<SheetWiring | null>(null)

export function useWiring(): SheetWiring {
  const wiring = React.useContext(SheetContext)
  if (wiring === null) {
    throw new Error("SheetScreen: render inside <SheetContext.Provider>")
  }
  return wiring
}
